import styled from 'styled-components';
import { Box, Paper, Button, List, Typography, ListItemIcon } from '@mui/material';

export const StartStepContainer = styled(Box)`
  max-width: 700px;
  margin: 0 auto;
  padding: 40px 24px;
`;

export const InfoCard = styled(Paper)`
  background-color: #f8fafc !important;
  border-radius: 24px !important;
  padding: 32px;
  border: 1px solid #e2e8f0 !important;
`;

export const SectionLabel = styled(Typography)`
  color: #0061ff;
  font-weight: 700 !important;
  letter-spacing: 0.1em !important;
  text-transform: uppercase;
  display: block;
  margin-top: 16px;
  margin-bottom: 8px;
`;

export const StyledList = styled(List)`
  padding: 0;
`;

export const FileIconWrapper = styled(ListItemIcon)<{ $isMandatory: boolean }>`
  min-width: 36px;
  margin-top: 4px;
  color: #0061ff !important;

  svg {
    font-size: 20px;
  }
`;

export const StatusChip = styled.span<{ $isMandatory: boolean }>`
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 4px;
  text-transform: uppercase;
  font-weight: 700;
  margin-left: 8px;
  background-color: ${(props) => (props.$isMandatory ? '#fdeded' : '#eef2f8')};
  color: ${(props) => (props.$isMandatory ? '#d32f2f' : '#0061ff')};
  border: 1px solid ${(props) => (props.$isMandatory ? '#f5c2c2' : '#d0d7de')};
  display: inline-block;
`;

export const StartButton = styled(Button)`
  margin-top: 48px !important;
  padding: 16px 48px !important;
  border-radius: 14px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  background-color: #0061ff !important;
  box-shadow: 0 4px 20px rgba(0, 97, 255, 0.15) !important;

  &:hover {
    background-color: #0052db !important;
    box-shadow: 0 6px 24px rgba(0, 97, 255, 0.25) !important;
  }
`;
